import { AxiosResponse } from 'axios';
import { APIService } from '../../shared/services/APIService';
import { Image } from '../models/Image';

export class AdminImageService extends APIService {

  /**
   * Get many decision trees
   */
  getMany(): Promise<AxiosResponse<Image[]>> {
    return this.http.get<Image[]>('/images');
  }

  /**
   * Download a decision tree by name
   */
  downloadOne(name: string) {
    return this.http.get<Blob>(`/images/${name}/download`, { responseType: 'blob' });
  }

  /**
   * Upload many decision trees
   */
  uploadMany(files: File[]) {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }
    return this.http.post<void>(`/images/upload`, formData);
  }

  /**
   * Delete one decision tree
   */
  deleteOne(name: string) {
    return this.http.delete<void>(`/images/${name}`);
  }
}
